



'use client';

import type React from 'react';
import { Box } from '@chakra-ui/react';
import { useContext, useEffect, useRef, useState } from 'react';
import { Buttons } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { Card } from '../../../../components/ui/card';
import { Badge } from '../../../../components/ui/badge';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../imports/svg-knollny4nu';
import toast, { Toaster } from 'react-hot-toast';
import imgBackground from '../../../../../src/assets/img/NewUI_Images/background.png';
import imgPlatform from '../../../../../src/assets/img/NewUI_Images/platform.png';
import { useColor } from '../../../../components/ui/ColorContext';
import * as THREE from 'three';
import { Canvas } from 'react-three-fiber';
import { ProfileContext } from '../EntirePreview';
import { updateLearnerMentorName } from 'utils/gameApplication/gamePlayService';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import { ScoreContext } from '../GamePreview';
import { updateScreenActivity } from '../common';

 
declare global {
  interface Window {
    _videoBlobCache?: Map<string, string>;
  }
}
  const NavigationArrow: React.FC<{
    direction: 'left' | 'right';
    onClick: () => void;
    isBlinking?: boolean;
  }> = ({ direction, onClick, isBlinking }) => {
    const { primaryColor } = useColor();
  
    const shouldBlink = direction === "right" && isBlinking;
  
    return (
      <Buttons
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="h-[2.125rem] w-[3.125rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(${
            direction === 'left' ? '275.041deg' : '90deg'
          },
          rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
            primaryColor,
          )}, 0.15) 84.803%)`,
          border: `1px solid ${primaryColor}`,
  
          boxShadow: shouldBlink
            ? `0 0 10px ${primaryColor},
               0 0 25px ${primaryColor},
               0 0 40px ${primaryColor}`
            : `0px 0px 15.9542px 0px rgba(${hexToRgb(
                primaryColor,
              )}, 0.3)`,
  
          animation: shouldBlink ? "blinkGlow 1s infinite" : "none",
        }}
      >
        {direction === 'left' ? (
          <ChevronLeft className="!h-4 !w-4 text-white" />
        ) : (
          <ChevronRight className="!h-4 !w-4 text-white" />
        )}
      </Buttons>
    );
  };

const SkipButton = ({ onClick }: { onClick: () => void }) => {
  const { primaryColor } = useColor();

  return (
    <button
      onClick={onClick}
      //  className="absolute bottom-6 right-6 z-50 rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
      className="fixed bottom-6 right-6 z-50 rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
      style={{
        background: 'rgba(0,0,0,0.55)',
        border: `1px solid ${primaryColor}`,
        boxShadow: `0 0 12px ${primaryColor}`,
        marginBottom: '11rem',
        marginRight: '4rem'
      }}
    >
      Skip
    </button>
  );
};

  const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};
interface Character {
  id: number;
  name: string;
  stats: {
    attack: number;
    speed: number;
    defense: number;
    damage: number;
  };
  icon: 'ranking' | 'male' | 'female' | 'settings';
}

interface PlayGamesProps {
  formData?: any;
  state?: any;
  dispatch?: any;
  setDatas?: any;
  imageSrc?: any;
  setCurrentScreenId?: any;
  players?: any;
  setSelectedPlayer?: any;
  profileData?: any;
  setProfileData?: any;
  demoBlocks?: any;
  preloadedAssets?: any;
  currentScreenId: any;
  ModelPlayer: any;
  setLearnerPlayingDetails: any;
  learnerPlayList: any;
  backgroundtheme: any;
  selectedBackground: any;
  audioObj:any; 
  setAudioObj:any;
}


// Helper function to convert hex to RGB


const MentorCharacterSelectionFutureTheme: React.FC<
  PlayGamesProps & {
    onNavigate?: (direction: 'left' | 'right') => void;
  }
> = ({
  formData,
  state,
  dispatch,
  setDatas,
  imageSrc,
  setCurrentScreenId,
  players,
  setSelectedPlayer,
  profileData,
  setProfileData,
  demoBlocks,
  preloadedAssets,
  currentScreenId,
  ModelPlayer,
  setLearnerPlayingDetails,
  learnerPlayList,
  backgroundtheme,
  selectedBackground,
  audioObj, 
  setAudioObj,
  onNavigate, // existing prop
}) => {
  const { deviceInfo,setlearnerActivityrec} = useContext(ScoreContext);
  const audioRef = useRef(null);
  const { primaryColor } = useColor();
    const [isTransitioning, setIsTransitioning] = useState(false);
  const [blackScreen, setBlackScreen] = useState(false);
 const [characterBlink, setCharacterBlink] = useState(false);
 const [bottomBlink, setBottomBlink] = useState(false);
  const [showFloatingHub, setShowFloatingHub] = useState(false);
  const [showQuestHub, setShowQuestHub] = useState(false);

  const useData = useContext(ProfileContext);


  const [formState, setFormState] = useState<any>({
    name: '',
  });

  const videoRef = useRef<HTMLVideoElement | null>(null);
    const startPortalTransition = (
      actionAfterTransition: () => void,
      duration = 5000
    ) => {
      setIsTransitioning(true);

      setTimeout(() => {
        setIsTransitioning(false);
        actionAfterTransition();
      }, duration);
    };
  const goToNextPage = () => {
     setlearnerActivityrec((prev:any)=>
        updateScreenActivity(
          prev,
          20,
          "Mentor Selection",
          deviceInfo,
          {
            mentor_gender: selectedCharacter?.id,
            selectedmentor_charcter: selectedCharacter?.name,
            mentornickname : formState.name,
          }
          
        )
      );
     try {
                const audio = new Audio(BtnClickSound as string);
                audio.volume = 1;
                audio.play().catch(() => { });

                // ⏱ Optional: Stop it after 2 seconds
                setTimeout(() => {
                    audio.pause();
                    audio.currentTime = 0;
                }, 1000);
            } catch (e) {
                // ignore audio errors
            }

              startPortalTransition(() => {
    setShowFloatingHub(true);
  });
    // setShowFloatingHub(true); // Trigger FloatingHub to show
  };

  useEffect(() => {
    if (showFloatingHub && videoRef.current) {
      videoRef.current.play(); // Safely play the video once it's rendered
    }
  }, [showFloatingHub]); // This runs whenever `showFloatingHub` is updated


  const [playerToast, setPlayerToast] = useState<string | null>(null);



const Toast = ({
  message,
  showPointer = true, // NEW PROP
}: {
  message: string;
  showPointer?: boolean;
}) => (
  <Box
    position="absolute"
    top="-68px"
    left="50%"
    transform="translateX(-50%)"
    minW="180px"
    maxW="460px"
    px="16px"
    py="12px"
    textAlign="center"
    borderRadius="10px"
    fontSize="12px"
    fontWeight="600"
    letterSpacing="0.4px"
    whiteSpace="normal"
    zIndex={1000}
    bg="rgba(10, 15, 30, 0.9)"
    // color="#3CFFC6"
    // border="2px solid #3CFFC6"
    backdropFilter="blur(6px)"
     color={primaryColor}
 boxShadow={`
      0 0 10px rgba(${hexToRgb(primaryColor)}, 0.8),
      0 0 25px rgba(${hexToRgb(primaryColor)}, 0.5),
      inset 0 0 10px rgba(${hexToRgb(primaryColor)}, 0.4)
    `}
    // boxShadow="
    //   0 0 10px rgba(60,255,198,0.8),
    //   0 0 25px rgba(60,255,198,0.5),
    //   inset 0 0 10px rgba(60,255,198,0.4)
    // "
  >
    {message}

    {showPointer && (
      <Box
        position="absolute"
        bottom="-12px"
        left="50%"
        transform="translateX(-50%) rotate(45deg)"
        width="100px"
        height="18px"
        bg="rgba(10, 15, 30, 0.95)"
        // borderRight="2px solid #3CFFC6"
        // borderBottom="2px solid #3CFFC6"
         borderRight={`2px solid ${primaryColor}`}   // ✅ theme color
          borderBottom={`2px solid ${primaryColor}`}
        boxShadow="0 0 10px rgba(60,255,198,0.8)"
      />
    )}
  </Box>
);

const bottomBlinkTimerRef = useRef<NodeJS.Timeout | null>(null);const triggerBottomBlink = () => {
  setBottomBlink(false);

  if (bottomBlinkTimerRef.current) {
    clearTimeout(bottomBlinkTimerRef.current);
  }

  bottomBlinkTimerRef.current = setTimeout(() => {
    if (formState.name.trim()) {
      setBottomBlink(true);
    }
  }, 6000);
};


  const selectPlayerClick = async () => {
    // Your existing logic to select a player
    if (!formState.name.trim()) {
      // toast.error('Please Enter Your Name', {
      //   duration: 3000,
      //   position: 'top-right',
      // });
      setPlayerToast("Please enter your name");
setTimeout(() => setPlayerToast(null), 10000);
return;

    
    }

    const data = {
      learnerPlayList: {
        ...learnerPlayList,
        LearnerProfile: {
          ...learnerPlayList?.LearnerProfile,
          mentorName: formState.name.trim(),
        },
      },
    };

    const dataString = JSON.stringify(data);
    const UpdateLearnerMentorname = await updateLearnerMentorName(dataString);

    if (
      UpdateLearnerMentorname?.status === 'Success' &&
      UpdateLearnerMentorname?.data
    ) {
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        LearnerProfile: {
          ...prev.LearnerProfile,
          mentorName: UpdateLearnerMentorname?.data?.mentorName,
        },
      }));
    }

    setProfileData((prev: any) => ({
      ...prev,
      mentorname: formState.name,
    }));

    setTimeout(() => {
      setSelectedPlayer(players[0]);
      goToNextPage(); // Trigger the floating hub and video
    }, 300);
  };
useEffect(() => {
  if ((showFloatingHub || showQuestHub) && audioObj) {
    try {
      audioObj.pause();
      audioObj.currentTime = 0; // optional: reset
    } catch (e) {}
  }
}, [showFloatingHub, showQuestHub]);

   const handleInputChange = (e: any) => {
    const { value } = e.target;
    const trimmedValue = value.slice(0, 15);

    setFormState((prevState: any) => ({
      ...prevState,
      name: trimmedValue,
    }));
    setLearnerPlayingDetails((prevState: any) => ({
      ...prevState,
      LearnerProfile: {
        ...prevState.LearnerProfile,
        mentorName: trimmedValue, // Set the new name as the mentor name
      },
    }));
  };
  const [rightBlink, setRightBlink] = useState(false);
     useEffect(() => {
   const timer = setTimeout(() => {
     setCharacterBlink(true);
   }, 6000);
 
   return () => clearTimeout(timer);
 }, []);
  useEffect(() => {}, [formState.name]);

  let theme: string | string[] = '';
  if ([1, 2, 3].includes(backgroundtheme?.gasId)) {
    theme = 'Medieval';
  } else if ([4, 5, 6,].includes(backgroundtheme?.gasId)) {
    theme = 'Future';
  } else if ([10, 11, 12].includes(backgroundtheme?.gasId)) {
    theme = 'Real';
  } else if ([7, 8, 9].includes(backgroundtheme?.gasId)) {
    theme = ['Magical'];
  } else if ([149, 150, 151, 152].includes(backgroundtheme?.gasId)) {
    theme = ['FutureThemeMentor'];
  }

  const matchingCharacter = preloadedAssets?.Player_Image?.filter((char: any) =>
    Array.isArray(theme) ? theme.includes(char.theme) : char.theme === theme,
  );

  const [blinking, setBlinking] = useState(false);

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [selectedCharacter, setSelectedCharacter] = useState(
    matchingCharacter[0],
  );

  const [selectedIndex, setSelectedIndex] = useState(0); // Initialize index as 0
  const choosegender =
    profileData?.gender && profileData?.gender === 'Female'
      ? preloadedAssets.Player_Image[1]
      : preloadedAssets.Player_Image[0];
  // const [selectedCharacter, setSelectedCharacter] = useState(preloadedAssets.Player_Image[0]);
  const [toggleLeftCharacter, setToggleLeftCharacter] = useState(false);
  const [toggleRightCharacter, setToggleRightCharacter] = useState(false);

  const getTexture = (selected: number): THREE.Texture => {
    const asset = selectedCharacter;

    return new THREE.TextureLoader().load(
      asset?.src || 'fallback-image-url.png',
    );
  };

  useEffect(() => {
    if (selectedCharacter?.id) {
      // setProfileData((prev: any) => ({
      //   ...prev,
      //   mentorgender: selectedCharacter?.id,
      //   mentorselectedplayer: selectedCharacter?.name,
      // }));
      let charactername = "";
      if (selectedCharacter?.id === "male") {
        charactername = "Zane"
      } else if (selectedCharacter?.id === "female") {
        charactername = "Elara"
      }
      setProfileData((prev: any) => ({
        ...prev,
        mentorgender: selectedCharacter?.id,
        mentorselectedplayer: selectedCharacter?.name,
      }));
      setFormState((prev: any) => ({
        ...prev,
        name: charactername,
      }));
     
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        mentor_gender: selectedCharacter?.id,
        mentorName: charactername,
        selectedmentor_charcter: selectedCharacter?.name,
      }));
    }
  }, [selectedCharacter]);

  const prevCharacter = () => {
    setSelectedIndex((prevIndex) => {
      const newIndex =
        (prevIndex - 1 + matchingCharacter.length) % matchingCharacter.length;
      setSelectedCharacter(matchingCharacter[newIndex]);
      return newIndex;
    });
  };

  const nextCharacter = () => {
    setSelectedIndex((prevIndex) => {
      const newIndex = (prevIndex + 1) % matchingCharacter.length;
      setSelectedCharacter(matchingCharacter[newIndex]);
      return newIndex;
    });
  };
  const skipAllVideos = () => {
  try {
    // Stop any playing video
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }

    // Stop background audio
    if (audioObj) {
      audioObj.pause();
      audioObj.currentTime = 0;
    }

    stopAllAudio();
  } catch (e) {}

  // Reset states
  setShowFloatingHub(false);
  setShowQuestHub(false);
  setIsTransitioning(false);

  // Go directly to final screen
  setCurrentScreenId(13);
};


  const goToPreviousPage = () => {
      try {
                const audio = new Audio(BtnClickSound as string);
                audio.volume = 1;
                audio.play().catch(() => { });

                // ⏱ Optional: Stop it after 2 seconds
                setTimeout(() => {
                    audio.pause();
                    audio.currentTime = 0;
                }, 1000);
            } catch (e) {
                // ignore audio errors
            }
    setBlackScreen(true); // Trigger black screen fade effect
    setTimeout(() => {
      setCurrentScreenId(1); // Reflection page screen id
    }, 1000); // Delay 1 second for effect
  };

  const stopAllAudio = () => {
  // Stop <audio> tags
  const audios = document.querySelectorAll('audio');
  audios.forEach((audio) => {
    audio.pause();
    audio.currentTime = 0;
  });

  // Stop WebAudio contexts (if used)
  if ((window as any).AudioContext || (window as any).webkitAudioContext) {
    try {
      const AudioCtx =
        (window as any).AudioContext || (window as any).webkitAudioContext;
      const ctx = new AudioCtx();
      ctx.suspend();
    } catch (e) {}
  }
};
useEffect(() => {
  if (showFloatingHub) {
    stopAllAudio();
  }
}, [showFloatingHub]);
useEffect(() => {
  if (showQuestHub) {
    stopAllAudio();
  }
}, [showQuestHub]);

//kishore hub video start

// ==================== VIDEO BLOB CACHE (FloatingHub + QuestHub) ====================
  const [floatingHubBlobUrl, setFloatingHubBlobUrl] = useState<string>(() => {
    const src = preloadedAssets?.FloatingHub;
    if (src && window._videoBlobCache?.has(src)) {
      return window._videoBlobCache.get(src)!;
    }
    return '';
  });

  const [questHubBlobUrl, setQuestHubBlobUrl] = useState<string>(() => {
    const src = preloadedAssets?.QuestHubVideo;
    if (src && window._videoBlobCache?.has(src)) {
      return window._videoBlobCache.get(src)!;
    }
    return '';
  });

  // 🔒 duplicate fetch varama irukka in-flight tracker
  const inFlightFetchesRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const videosToCache: {
      src: string | undefined;
      setter: React.Dispatch<React.SetStateAction<string>>;
      label: string;
    }[] = [
      { src: preloadedAssets?.FloatingHub, setter: setFloatingHubBlobUrl, label: 'FloatingHub' },
      { src: preloadedAssets?.QuestHubVideo, setter: setQuestHubBlobUrl, label: 'QuestHubVideo' },
    ];

    videosToCache.forEach(({ src, setter, label }) => {
      if (!src) {
        console.warn(`[VideoCache-Mentor] ${label} src ILLA`);
        return;
      }

      // ✅ already cache la irundha direct ah use pannunga
      if (window._videoBlobCache && window._videoBlobCache.has(src)) {
      
        setter(window._videoBlobCache.get(src)!);
        return;
      }

      // ✅ already fetch nadakkuthுna, rendaam fetch start pannாதே
      if (inFlightFetchesRef.current.has(src)) {
       
        return;
      }

      inFlightFetchesRef.current.add(src);
    
      const fetchStartTime = performance.now();

      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'video';
      link.href = src;
      document.head.appendChild(link);

      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          if (!window._videoBlobCache) {
            window._videoBlobCache = new Map();
          }
          window._videoBlobCache.set(src, blobUrl);
          setter(blobUrl);

          const timeTaken = ((performance.now() - fetchStartTime) / 1000).toFixed(2);
         
        })
        .catch((err) => {
          console.error(`[VideoCache-Mentor] ❌ ${label} fetch FAIL:`, err);
          setter(src); // fallback
        })
        .finally(() => {
          inFlightFetchesRef.current.delete(src);
        });
    });
  }, [preloadedAssets?.FloatingHub, preloadedAssets?.QuestHubVideo]);

//kishore hub video end

  return (
    <>
 <style>
      {`
        @keyframes blinkGlow {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.15); opacity: 0.6; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}
    </style>
    
        {isTransitioning && (
          <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black">
            <div
              className="hud-core hud-core-big"
           


            >
              <div className="hud-halo" />
              <div className="hud-ring hud-ring-outer" />
              <div className="hud-ring hud-ring-middle" />
              <div className="hud-ring hud-ring-inner" />
              <div className="hud-arc hud-arc-1" />
              <div className="hud-arc hud-arc-2" />
              <div className="hud-dot hud-dot-1" />
              <div className="hud-dot hud-dot-2" />
              <div className="hud-center" />
              <div className="hud-scan" />
            </div>
          </div>
        )}
        {/* //kishore hub video start */}
      {showFloatingHub && (
        <div className="transition-overlay">
           <SkipButton onClick={skipAllVideos} />
          {/* Floating Hub Video */}
          {/* <video
            ref={videoRef}
            src={preloadedAssets?.FloatingHub}
             muted={false} 
            autoPlay
            playsInline
            preload="auto"
            className="transition-video"
            style={{ visibility: showFloatingHub ? 'visible' : 'hidden' }}

          /> */}


           <video
              ref={videoRef}
              src={floatingHubBlobUrl}
              muted={false}
              autoPlay
              playsInline
              preload="auto"
              className="transition-video"
              style={{ visibility: showFloatingHub ? 'visible' : 'hidden' }}
            />
{/* //kishore hub video end */}
          {/* Text */}
          <div className="transition-text">
            <div className="relative h-screen w-full overflow-hidden bg-cover bg-center bg-no-repeat">
              <div className="relative flex h-full w-full   px-4 sm:px-6 lg:px-8">
                {/* Dialogue Content */}
                <div className="flex h-full flex-grow flex-col items-center justify-end">
                  <div
                    className="relative flex h-full max-h-fit  w-full flex-col items-center justify-start rounded-2xl px-6 py-5"
                    style={{
                      background: `rgba(0,0,0,0.45)`, // blackish
                      backdropFilter: 'blur(30px)', // strong blur
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.35)`, // glowing border
                    }}
                  >
                    <div className="flex w-full max-w-screen-xl mx-auto items-start gap-6 sm:gap-8 lg:gap-10">
                      <div className="w-full">
                        <div className="relative">
                          <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>
                          <div className="pointer-events-none absolute -top-[7.5rem] left-10 h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>

                          <div className="relative z-10 w-full">
                            <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight">
                              <div className="w-full">
                                <p className="block max-h-[134px] min-h-[6rem] cursor-pointer overflow-y-auto ps-1 text-white transition-all duration-300 hover:opacity-90">
                                  Welcome to NEO-ORBITAL LAB 7. The year is
                                  2050. Cars glide through the sky, and AI
                                  powers daily life. But one ambition remains
                                  out of reach: a humanoid AI built to help
                                  people live their best lives.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="absolute bottom-6 right-6 z-50 flex items-center">
                      <NavigationArrow
                        direction="right"
                        // onClick={() => setIsReplayPointDialogOpen(true)}
                        onClick={() => {
                          setShowFloatingHub(false);
                          setShowQuestHub(true); // Move to Stage 2
                        }}
                      />
                    </div>

                    <div
                      className="pointer-events-none absolute inset-0 rounded-2xl"
                      style={{
                        boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.2)`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* //kishore hub video start */}
      {showQuestHub && (
        <div className="transition-overlay">
          {/* Quest Hub Video */}
           <SkipButton onClick={skipAllVideos} />
          {/* <video
           muted={false} 
            src={preloadedAssets?.QuestHubVideo}
            autoPlay
            playsInline
            preload="auto"
            className="transition-video"
 
          /> */}

           <video
              muted={false}
              src={questHubBlobUrl}
              autoPlay
              playsInline
              preload="auto"
              className="transition-video"
            />

            {/* //kishore hub video start */}
          <div className="transition-text">
            <div className="relative h-screen w-full overflow-hidden bg-cover bg-center bg-no-repeat">
              <div className="relative flex h-full w-full   px-4 sm:px-6 lg:px-8">
                {/* Dialogue Content */}
                <div className="flex h-full flex-grow flex-col items-center justify-end">
                  <div
                    className="relative flex h-full max-h-fit w-full flex-col items-center justify-start rounded-2xl px-6 py-5"
                    style={{
                      background: `rgba(0,0,0,0.45)`, // blackish
                      backdropFilter: 'blur(30px)', // strong blur
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.35)`,
                      minHeight:"10rem" // glowing border
                    }}
                  >
                    <div className="flex w-full max-w-screen-xl mx-auto items-start gap-6 sm:gap-8 lg:gap-10">
                      <div className="w-full">
                        <div className="relative">
                          <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>
                          <div className="pointer-events-none absolute -top-[7.5rem] left-10 h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>

                          <div className="relative z-10 w-full">
                            <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight">
                              <div className="w-full">
                                <div className="transition-dark-overlay">
                                  <p className="block max-h-[134px] min-h-[6rem] cursor-pointer overflow-y-auto ps-1 text-white transition-all duration-300 hover:opacity-90">
                                    Humanity calls this dream Project ECHO, the
                                    world's boldest attempt to build a true AI
                                    teammate. And you’ve been chosen to lead it.
                                    Tensions are high, stakes even higher. The
                                    world is watching. Can you launch ECHO?
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="absolute bottom-6 right-6 z-50 flex items-center">
                      <NavigationArrow
                        direction="right"
                        onClick={() => {
                          setShowQuestHub(false);
                          // setCurrentScreenId(13); // Final screen
                           startPortalTransition(() => {
                              setCurrentScreenId(13);
                            }, 5000);
                        }}
                      />
                    </div>

                    <div
                      className="pointer-events-none absolute inset-0 rounded-2xl"
                      style={{
                        boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.2)`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {playerToast && (
  <Box position="absolute" top="12%" left="50%" transform="translateX(-50%)" zIndex={99999999}>
    <Toast message={playerToast} showPointer={false} />
  </Box>
)}


      {/* <Toaster position="top-right"  /> */}
{(!showFloatingHub && !showQuestHub) && (
      <div
        className="relative h-screen w-full overflow-y-auto bg-black/90 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('${imgBackground}')` }}
      >
        <div className="relative w-full px-4 sm:px-6 lg:px-8">
        
          {/* Character Selection Section */}
          <div className="flex h-screen pt-32">
            <div className="relative h-full flex-grow">
              <div className="lg:bottom-19 absolute bottom-14 left-1/2 z-20 w-full max-w-[27rem] -translate-x-1/2 transform">
                <p className="lg:top-22 glow-text relative top-20 text-center font-venora text-3xl font-bold tracking-wide text-white">
                  Select Mentor Character
                </p>
                <div className="relative top-10 mx-auto max-h-[calc(100svh-80px)] max-w-full text-center lg:top-12 lg:max-h-[45rem] lg:max-w-[25rem]">
                  <img
                    src={selectedCharacter?.src || '/placeholder.svg'}
                    alt={selectedCharacter?.name || 'character'}
                    className="select-none max-lg:mx-auto max-lg:max-h-[inherit] max-lg:w-auto lg:h-full lg:w-full lg:object-contain"
                  />
                </div>
                {/* Navigation Arrows */}
                <div className="absolute bottom-1/2 flex w-full -translate-y-2/2 transform items-center justify-between gap-3"
                style={{marginLeft:"-13px"}}
                >
                  <NavigationArrow direction="left" onClick={prevCharacter} />
                  <NavigationArrow direction="right" onClick={nextCharacter} isBlinking={characterBlink} />
                </div>
              </div>

              {/* Glowing effect */}
              <div
                className="absolute bottom-12 left-1/2 h-[35.75rem] w-[26.375rem] -translate-x-1/2 transform rounded-full opacity-15 mix-blend-hard-light blur-[6.875rem]"
                style={{
                  background: primaryColor,
                }}
              />

              {/* Platform */}
              <div className="absolute bottom-0 w-full max-w-[80%] pl-[19%]">
                <img
                  src={imgPlatform || '/placeholder.svg'}
                  alt="platform"
                  className="h-full w-full object-contain"
                />
              </div>

              {/* Name Input */}
              <div className="absolute bottom-12 left-1/2 z-20 -translate-x-1/2 transform">
                <Card
                  className="relative h-16 w-80 rounded-lg border-none bg-[#1A1A1A]"
                  style={{
                    border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
                    boxShadow: `0px 0px 6px 1px rgba(${hexToRgb(
                      primaryColor,
                    )}, 0.5)`,
                  }}
                >
                  <div
                    className="absolute inset-2.5 flex items-center justify-center rounded-md px-0"
                    style={{
                      background: `rgba(${hexToRgb(primaryColor)}, 0.1)`,
                      border: `1px solid rgba(${hexToRgb(primaryColor)})`,
                      boxShadow: `inset 0px 0px 2.69259px 0px rgba(${hexToRgb(
                        primaryColor,
                      )}, 0.24)`,
                    }}
                  >
                    <Input
                      type="text"
                      value={formState.name}
                      readOnly
                      // onChange={handleInputChange}
                      onChange={(e) => {
                         triggerBottomBlink(); 
                          }}
                      placeholder="Enter Name"
                      className="font-glancyr-neue border-none bg-transparent pt-2 text-center !text-lg font-medium tracking-[0.07rem] text-white shadow-none outline-none placeholder:text-white/70 focus-visible:ring-0"
                    />
                  </div>
                </Card>
              </div>
            </div>
          </div>

          {/* Bottom Navigation */}
          <div className="absolute bottom-16 left-12 right-12 flex items-center justify-between">
            <NavigationArrow direction="left" onClick={goToPreviousPage} />
            <NavigationArrow
              direction="right"
              // onClick={goToNextPage}
              onClick={selectPlayerClick}
               isBlinking={bottomBlink}
            />
          </div>
        </div>
      </div>
)}
    </>
  );
};

export default MentorCharacterSelectionFutureTheme;


